module.exports = __webpack_public_path__ + "static/7-7070c789bfd9316b8572efe0c702024e.jpg";